"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effect = void 0;
const SinkBuilder_1 = require("../SinkBuilder");
/**
 * override function to effect dispatch function,
 * the `action.type` will be `{namespace}/{effect name}`,
 * all parameters it take will be transform into `action.payload`
 * @param {Object} [target] prototype
 * @param {string} [name] name of effect
 * @param {Object} [descriptor] function to handle effect
 */
function effect(target, name, descriptor) {
    const sinkBuilder = SinkBuilder_1.SinkBuilder.get(target);
    sinkBuilder.effects[name] = descriptor.value;
}
exports.effect = effect;
